import {componentLoader, componentConfig} from "../../../lib/component_initializer";
import {OnlineAppRoot} from "./online_app_root"

export const onlineAppRootLoader = function (options = {}) {
    componentLoader(componentConfig(OnlineAppRoot, OnlineAppRoot.config.componentTypeKey, OnlineAppRoot.config.baseHtmlClass), options);
};

